import React from "react";

// Couleurs imposées par le besoin métier : vert = terminé, orange = terminé
// avec erreurs, rouge = échec, bleu = en cours. "En attente" n'est pas décrit
// dans le besoin : on le représente en gris neutre, en attendant qu'il démarre.
const STATUT_BADGE_CLASS = {
  EN_ATTENTE: "badge-secondary",
  EN_COURS: "badge-info",
  TERMINE: "badge-success",
  TERMINE_AVEC_ERREURS: "badge-warning",
  ECHEC: "badge-danger",
};

/**
 * Badge de statut d'import, coloré selon le code renvoyé par l'API.
 * Le libellé affiché vient toujours de `statutLabel` (fourni par l'API).
 */
const StatutImportBadge = ({ statut, statutLabel }) => (
  <span
    className={"badge " + (STATUT_BADGE_CLASS[statut] || "badge-secondary")}
  >
    {statutLabel}
  </span>
);

export default StatutImportBadge;
